import loadingGif from "../../assets/loading-200px.svg";
// import logoBlack from "../../assets/gt-home logo.svg";
import logoBlack from "../../assets/logo.svg";

const Loading = () => {
  const style = {
    display: "grid",
    placeItems: "center",
    width: "100vw",
    height: "100vh"
  }
  return (
    <div className="loading" style={style}>
      
      <div>
        <img src={loadingGif} alt="loading svg icon" style={{display: "block"}}/>
        <img src={logoBlack} alt="logo" />
      </div>
    </div>
  );
};

export default Loading;
